import { withStyles } from '@material-ui/core/styles'
import AccordionDetails from '@material-ui/core/AccordionDetails'

const CustomExpansionPanelDetails = withStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 24px'
  }
})(AccordionDetails)

export default CustomExpansionPanelDetails
